export const storeName = 'translations';

export default {};
